/* Core deposit sync. Remanufactured parts carry a refundable core deposit, charged as its own cart line
 * (the "Refundable Core Deposit" product, one variant per amount). This keeps that line in step with the
 * part: added with it, same quantity, removed with it, re-added if the buyer deletes only the deposit.
 * Map of part variant -> amount and amount -> deposit variant comes from cpg-core-map.json (built from
 * the custom.core_charge metafields). Runs after every cart change, on page load, and before checkout. */
(function () {
  if (window.__cpgCoreDeposit) return;
  window.__cpgCoreDeposit = true;

  var script = document.currentScript;
  var MAP_URL = script && script.getAttribute('data-map');
  if (!MAP_URL) return;

  var nativeFetch = window.fetch.bind(window);
  var mapPromise = null;
  function loadMap() {
    if (!mapPromise) mapPromise = nativeFetch(MAP_URL, { credentials: 'omit' }).then(function (r) { return r.json(); }).catch(function () { return null; });
    return mapPromise;
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var onCartPage = /^\/cart\/?$/.test(location.pathname);
  var timer = null;
  function schedule() { window.clearTimeout(timer); timer = window.setTimeout(sync, 250); }

  // Watch the theme's own cart calls (fetch and XHR). Our calls go through nativeFetch, so they never loop.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_MUTATION.test(url)) p.then(schedule, function () {});
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cpgCoreUrl = u; return xhrOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__cpgCoreUrl && CART_MUTATION.test(this.__cpgCoreUrl)) this.addEventListener('loadend', schedule);
    return xhrSend.apply(this, arguments);
  };

  function post(path, body) {
    return nativeFetch(path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Work out the deposit lines the cart should have, then add/change/remove to match.
  function plan(cart, map) {
    var depositAmountByVariant = {};
    Object.keys(map.deposits).forEach(function (amt) { depositAmountByVariant[map.deposits[amt]] = amt; });

    var needQty = {}, partTitle = {};
    cart.items.forEach(function (it) {
      if (map.parts[String(it.variant_id)]) {
        needQty[it.variant_id] = (needQty[it.variant_id] || 0) + it.quantity;
        partTitle[it.variant_id] = it.product_title || it.title;
      }
    });

    var ops = [], covered = {};
    cart.items.forEach(function (it) {
      if (!depositAmountByVariant[it.variant_id]) return;
      var part = it.properties && it.properties._core_for;
      var want = part ? needQty[part] || 0 : 0;
      var rightVariant = part && map.parts[part] && map.deposits[String(map.parts[part])] === it.variant_id;
      if (!want || !rightVariant || covered[part]) { ops.push({ remove: it.key }); return; }
      covered[part] = true;
      if (it.quantity !== want) ops.push({ key: it.key, qty: want });
    });
    Object.keys(needQty).forEach(function (part) {
      if (covered[part]) return;
      var variant = map.deposits[String(map.parts[part])];
      if (variant) ops.push({ add: variant, qty: needQty[part], props: { _core_for: String(part), 'For': partTitle[part] } });
    });
    return ops;
  }

  var running = null, rerun = false;
  function sync() {
    if (running) { rerun = true; return running; }
    running = loadMap().then(function (map) {
      if (!map) return false;
      return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ops = plan(cart, map);
          if (!ops.length) return false;
          return ops.reduce(function (p, op) {
            return p.then(function () {
              if (op.add) return post('/cart/add.js', { items: [{ id: op.add, quantity: op.qty, properties: op.props }] });
              if (op.remove) return post('/cart/change.js', { id: op.remove, quantity: 0 });
              return post('/cart/change.js', { id: op.key, quantity: op.qty });
            });
          }, Promise.resolve()).then(function () { return true; });
        });
    }).catch(function () { return false; }).then(function (changed) {
      running = null;
      if (changed) {
        document.dispatchEvent(new CustomEvent('cpg:core-synced'));
        // The cart page is server-rendered with positional quantity inputs; reload so they match the cart.
        // Guarded so a cart call that keeps failing can never cause a reload loop.
        if (onCartPage) {
          var last = 0;
          try { last = Number(sessionStorage.getItem('cpgCoreReload')) || 0; } catch (err) {}
          if (Date.now() - last > 10000) {
            try { sessionStorage.setItem('cpgCoreReload', String(Date.now())); } catch (err) {}
            location.reload();
            return changed;
          }
        }
      }
      if (rerun) { rerun = false; return sync(); }
      return changed;
    });
    return running;
  }
  window.cpgCoreDepositSync = sync;

  // Checkout guard: make sure the deposit is in place before leaving for checkout.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"]') : null;
    if (!t || t.__cpgCoreOk) return;
    e.preventDefault();
    e.stopPropagation();
    sync().then(function (changed) {
      if (changed && onCartPage) return; // page is reloading with the corrected cart
      t.__cpgCoreOk = true;
      if (t.tagName === 'A') location.href = t.href; else t.click();
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
